import React, { useState } from "react";

const UploadModal = ({ open, onClose, onSubmit }) => {
  const [name, setName] = useState("");
  const [credits, setCredits] = useState("");
  const [price, setPrice] = useState("");

  const reset = () => {
    setName("");
    setCredits("");
    setPrice("");
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name?.trim()) return;
    onSubmit({
      name: name.trim(),
      credits: credits ? Number(credits) : 0,
      price: price ? Number(price) : 0,
    });
    reset();
  };

  if (!open) return null;

  return (
    <div className="addon-modal-overlay" onMouseDown={handleClose}>
      <div
        className="addon-modal-container"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="addon-modal-head">
          <span>Add Add On Plan</span>
          <button
            type="button"
            className="addon-modal-close"
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <form className="addon-modal-form" onSubmit={handleSubmit}>
          <div className="addon-modal-field">
            <label className="addon-modal-label">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Add-on name"
              className="addon-modal-input"
              required
            />
          </div>
          <div className="addon-modal-field">
            <label className="addon-modal-label">Credits</label>
            <input
              type="number"
              value={credits}
              onChange={(e) => setCredits(e.target.value)}
              placeholder="Credits"
              className="addon-modal-input"
              min="0"
            />
          </div>
          <div className="addon-modal-field">
            <label className="addon-modal-label">Price</label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="Price"
              className="addon-modal-input"
              min="0"
            />
          </div>
          <div className="addon-modal-submit">
            <button type="button" className="my-btn addon-btn-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button type="submit" className="my-btn addon-btn-save">
              Add Plan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadModal;
